import React from "react";
import styled from "styled-components";

import { WorkspaceWithLicense } from "@examspark/api";
import { Button, VSpace } from "@examspark/common-ui";

const Styled = styled.div`
  padding: 5rem;
`;

const SelectWorkspace = (props: {
  header: React.ReactNode;
  workspaces: WorkspaceWithLicense[];
  onSelect: (workspace: WorkspaceWithLicense) => void;
}) => {
  return (
    <Styled>
      <VSpace size="3rem">
        {!!props.header && props.header}
        <div>
          <h1>Select your workspace!</h1>
          <h2>
            Your account belongs to more than one workspace. Select a workspace
            to continue.
          </h2>
        </div>
        <VSpace>
          {props.workspaces.map((workspace) => (
            <Button
              key={workspace.id}
              title=""
              onClick={() => props.onSelect(workspace)}
              variant="outlined"
            >
              {workspace.workspace.name}
            </Button>
          ))}
        </VSpace>
      </VSpace>
    </Styled>
  );
};

export default SelectWorkspace;
